import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import PropTypes from 'prop-types';
import { V2ModalDialog } from '@uhg-abyss/web/ui/ModalDialog';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { V2Button } from '@uhg-abyss/web/ui/Button';
import { useTinRegistration } from '@src/state/tinRegistration';

export const DraftValidationModel = ({
  isOpen,
  closeModal,
  handleStartRegistration,
}) => {
  const { disableSaveAsDraft } = useTinRegistration.actions();
  const handleCloseModal = () => {
    disableSaveAsDraft(false);
    closeModal();
  };

  const handleContinue = () => {
    handleStartRegistration();
    closeModal();
  };

  const ModalTextBody = styled('div', {
    margin: '5px 0 12px',
    lineHeight: '1.2',
    overflowWrap: 'break-word',
  });

  return (
    <V2ModalDialog
      id="draft-validation-modal"
      isOpen={isOpen}
      header="Saved Registration Limit Reached"
      hideClose
      closeOnClickOutside={false}
    >
      <ModalTextBody id="draft-validation-modal-modal">
        If you wish to continue, you will not be able to save additional
        sessions.
      </ModalTextBody>
      <Layout.Group alignLayout="right" css={{ marginTop: '24px' }}>
        <V2Button onClick={handleContinue}>Yes</V2Button>
        <V2Button variant="outline" onClick={handleCloseModal}>
          No
        </V2Button>
      </Layout.Group>
    </V2ModalDialog>
  );
};

DraftValidationModel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  handleStartRegistration: PropTypes.func.isRequired,
};
